import { useToken } from "@chakra-ui/react";
import HolyLoader from "holy-loader";

export type NextLoaderProps = {
  showSpinner?: boolean;
};
export const ReactLoader = ({ showSpinner = false }: NextLoaderProps) => {
  const loaderColor = useToken("colors", "brand.600");
  return (
    <HolyLoader
      height={3}
      zIndex={99999}
      color={loaderColor}
      showSpinner={showSpinner}
    />
  );
};
